module.exports = __webpack_public_path__ + "41359ccc4d5e0ca081c09d3666b96a9d.svg";